export const rateGroupQueryKeys = {
  all: ['rate-groups'] as const,
  lists: () => [...rateGroupQueryKeys.all, 'list'] as const,
  list: (vendorId: string | undefined) => [...rateGroupQueryKeys.lists(), vendorId] as const,
  rules: (vendorId: string | undefined) => [...rateGroupQueryKeys.all, 'rules', vendorId] as const,
  ratesByGroup: (vendorId: string | undefined, rateCodes: ReadonlyArray<string>) =>
    [...rateGroupQueryKeys.all, 'rates-by-group', vendorId, rateCodes] as const,
  ungroupedRateDetails: (vendorId: string | undefined, departureId: string, rateIds: ReadonlyArray<string>) =>
    [...rateGroupQueryKeys.all, 'ungrouped-rate-details', vendorId, departureId, rateIds] as const,
  recommendations: (
    rates: ReadonlyArray<{
      id: string;
      description: string | null;
      rateCodeRemarks: string | null;
      isNonRefundable: boolean | null;
      rateCodeDetails: string | null;
    }>,
  ) => [...rateGroupQueryKeys.all, 'recommendations', rates] as const,
};
